<pdq-tabs-group variant="underline" (onChange)="onTabChange($event)" [leftMargin]="'none'">
  <pdq-tab label="Order & Management" value="order-management" [active]="activeTab === 'order-management'"></pdq-tab>
  <pdq-tab label="Timer" value="timer" [active]="activeTab === 'timer'"></pdq-tab>
  <pdq-tab
    label="Display Conditions"
    value="display-conditions"
    [active]="activeTab === 'display-conditions'"></pdq-tab>
</pdq-tabs-group>

@switch (activeTab) {
  @case ('order-management') {
    <smart-cart-form-token-section [token]="usageToken"></smart-cart-form-token-section>
    <pdq-card variant="popover" color="white">
      <div class="card">
        <div class="card__header">
          <div class="card__title-block">
            <pdq-heading element="h5">Appearance</pdq-heading>
            <span class="card__subtitle">The content that would show in the announcement bar</span>
          </div>
        </div>
        <pdq-divider></pdq-divider>
        <div class="card__content">
          <div class="field">
            <span class="field__label">Height</span>
            <pdq-dropdown
              [formControl]="formGroup.controls.height"
              [options]="heightOptions"
              fullWidth="true"></pdq-dropdown>
          </div>
          <div class="field-row">
            <pdq-input-color
              [formControl]="formGroup.controls.backgroundColor"
              label="Background Color"></pdq-input-color>
            <div class="field">
              <pdq-checkbox
                [formControl]="formGroup.controls.border.controls.enabled"
                label="Border"
                labelSize="small"></pdq-checkbox>
              @if (formGroup.controls.border.controls.enabled.value) {
                <pdq-input-color [formControl]="formGroup.controls.border.controls.color"></pdq-input-color>
              }
            </div>
          </div>
        </div>
      </div>
    </pdq-card>

    <pdq-card variant="popover" color="white">
      <div class="card">
        <div class="card__header">
          <div class="card__title-block">
            <pdq-heading element="h5">Messages</pdq-heading>
            <span class="card__subtitle">The content that would show in the announcement bar</span>
          </div>
        </div>
        <pdq-divider></pdq-divider>
        <div class="card__content">
          @if (formGroup.controls.messages.controls.length > 1) {
            <div class="rotate-row">
              <pdq-input-arrows
                [formControl]="formGroup.controls.messageRotation.controls.value"
                label="Rotate messages every"
                widthSize="fullwidth"
                [min]="1"
                placeholder="10"></pdq-input-arrows>
              <pdq-dropdown
                class="rotate-row__unit"
                [formControl]="formGroup.controls.messageRotation.controls.unit"
                [options]="rotationUnitOptions"
                [dirty]="false"></pdq-dropdown>
            </div>
          }

          @for (msgControl of formGroup.controls.messages.controls; track msgControl; let i = $index) {
            <div class="field">
              <div class="message-header">
                <span class="field__label message-header__label">Message {{ i + 1 }}</span>
                <div class="message-header__actions">
                  <pdq-button
                    icon="trash"
                    variant="ghost"
                    plain="true"
                    size="medium"
                    iconColor="var(--error-default)"
                    (onClick)="removeMessage(i)"></pdq-button>
                </div>
              </div>
              <rich-textarea
                [initialContent]="msgControl.controls.html.value"
                (contentChange)="onMessageHtmlChange(i, $event)"
                [enableLinkInsert]="true"
                placeholder="Use Code SAVE20"></rich-textarea>
              <span class="field__hint">Dynamic field available - {{ '{countdown}' }}</span>
              <pdq-input-color
                [formControl]="msgControl.controls.textColor"
                label="Text Color"
                [clearable]="true"
                clearTooltip="Use the theme's colour"
                (cleared)="msgControl.controls.textColor.setValue('')"></pdq-input-color>
            </div>
          }

          <pdq-button
            class="add-message"
            plain="true"
            variant="secondary"
            size="small"
            icon="Plus"
            label="Add Message"
            iconColor="var(--secondary-default)"
            labelColor="var(--secondary-default)"
            (onClick)="addMessage()"></pdq-button>
        </div>
      </div>
    </pdq-card>
  }
  @case ('timer') {
    <pdq-card variant="popover" color="white">
      <div class="card">
        <div class="card__header">
          <div class="card__title-block">
            <pdq-heading element="h5">Timer</pdq-heading>
            <span class="card__subtitle">Define timer to use in announcements</span>
          </div>
          <pdq-slide-toggle
            [defaultValue]="formGroup.controls.timer.controls.enabled.value"
            (onToggle)="formGroup.controls.timer.controls.enabled.setValue($event)"></pdq-slide-toggle>
        </div>
        @if (formGroup.controls.timer.controls.enabled.value) {
          <pdq-divider></pdq-divider>
          <div class="card__content">
            <div class="field">
              <span class="field__label">Timer Duration</span>
              <div class="rotate-row">
                <pdq-input-arrows
                  [formControl]="formGroup.controls.timer.controls.duration.controls.value"
                  widthSize="fullwidth"
                  [min]="1"
                  placeholder="10"></pdq-input-arrows>
                <pdq-dropdown
                  class="rotate-row__unit"
                  [formControl]="formGroup.controls.timer.controls.duration.controls.unit"
                  [options]="timerUnitOptions"
                  [dirty]="false"></pdq-dropdown>
              </div>
              <span class="field__hint">Timer starts when customer opens the smart cart</span>
            </div>

            <pdq-radio-group
              [formControl]="formGroup.controls.timer.controls.format"
              label="Time Format"
              alignment="vertical">
              <pdq-radio-button value="digital" text="Digital (01:30:45)"></pdq-radio-button>
              <pdq-radio-button value="compact" text="Compact (1Hr 30m)"></pdq-radio-button>
            </pdq-radio-group>

            <pdq-radio-group
              [formControl]="formGroup.controls.timer.controls.expirationBehavior"
              label="Expiration Behavior"
              alignment="vertical">
              <pdq-radio-button value="show_expired_message" text="Show Expired Message"></pdq-radio-button>
              <pdq-radio-button value="hide_message" text="Hide Message"></pdq-radio-button>
            </pdq-radio-group>

            @if (formGroup.controls.timer.controls.expirationBehavior.value === 'show_expired_message') {
              <div class="field">
                <div class="message-header">
                  <span class="field__label message-header__label">Message when time has expired</span>
                  <div class="message-header__actions">
                    <pdq-button
                      icon="preview_eye"
                      variant="ghost"
                      plain="true"
                      size="medium"
                      iconColor="var(--on-surface-default)"></pdq-button>
                  </div>
                </div>
                <rich-textarea
                  [initialContent]="formGroup.controls.timer.controls.expiredMessage.value"
                  (contentChange)="onExpiredMessageChange($event)"
                  [enableLinkInsert]="true"
                  [placeholder]="'Offer expired'"></rich-textarea>
                <span class="field__hint">Use {{ '{countdown}' }} to dynamically display the time remaining</span>
              </div>
            }
          </div>
        }
      </div>
    </pdq-card>
  }
  @case ('display-conditions') {
    @if (displayConditionsGroup; as displayConditionsForm) {
      <smart-cart-form-display-conditions [formGroup]="displayConditionsForm"></smart-cart-form-display-conditions>
    }
  }
}

<smart-cart-form-custom-code
  [enabledControl]="formGroup.controls.customCode.controls.enabled"
  [codeControl]="formGroup.controls.customCode.controls.code"
  [defaultCode]="starterTemplate"
  [variables]="customCodeVariables"></smart-cart-form-custom-code>
